(function () {
  'use strict';

  function money(cents) {
    var amount = Number(cents || 0) / 100;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var locale = document.documentElement.lang || 'en-US';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function hideNativeSubscriptionFallbacks() {
    if (!document.querySelector('[data-tea-product-section]')) return;

    var nativeSelectors = [
      '.shopify_subscriptions_app_block',
      '.shopify-subscriptions-app-block',
      '.shopify_subscriptions_app_container',
      '.shopify-subscriptions-app-container',
      '.shopify_subscriptions_purchase_option_wrapper',
      '.shopify_subscriptions_app_policy'
    ];

    document.querySelectorAll(nativeSelectors.join(',')).forEach(function (node) {
      if (node.closest('[data-tea-product-section]')) return;
      node.hidden = true;
      node.style.display = 'none';
    });

    var candidates = Array.prototype.slice.call(document.querySelectorAll('div, section, form, fieldset'));
    var fallback = candidates
      .filter(function (node) {
        if (node.closest('[data-tea-product-section]')) return false;
        if (node.querySelector('[data-tea-product-section]')) return false;
        var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
        return text.indexOf('To edit the placement of the subscription widget') !== -1
          || (
            text.indexOf('One-time purchase') !== -1
            && text.indexOf('Subscribe and save') !== -1
            && text.indexOf('Deliver every') !== -1
          );
      })
      .sort(function (a, b) {
        return (a.textContent || '').length - (b.textContent || '').length;
      })[0];

    if (fallback) {
      fallback.hidden = true;
      fallback.style.display = 'none';
    }
  }

  if (!window.__teaSubscriptionFallbackObserver) {
    window.__teaSubscriptionFallbackObserver = true;
    hideNativeSubscriptionFallbacks();
    window.setTimeout(hideNativeSubscriptionFallbacks, 250);
    window.setTimeout(hideNativeSubscriptionFallbacks, 1000);

    if (window.MutationObserver) {
      new MutationObserver(hideNativeSubscriptionFallbacks).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  }

  document.querySelectorAll('[data-tea-product-section]').forEach(function (section) {
    if (section.dataset.teaInitialized === 'true') return;
    section.dataset.teaInitialized = 'true';
    var controller = window.AbortController ? new AbortController() : null;

    function on(target, eventName, handler, options) {
      if (!target) return;
      var listenerOptions = options || {};
      if (controller) {
        listenerOptions = Object.assign({}, listenerOptions, { signal: controller.signal });
      }
      target.addEventListener(eventName, handler, listenerOptions);
    }

    function cleanup() {
      if (controller) controller.abort();
      delete section.dataset.teaInitialized;
    }

    if (window.Shopify && window.Shopify.designMode) {
      on(document, 'shopify:section:unload', function (event) {
        if (event.target && event.target.contains(section)) cleanup();
      });
    }

    var variantsEl = section.querySelector('[data-tea-variants-json]');
    var variants = [];
    try {
      variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    } catch (error) {
      variants = [];
    }

    var picker = section.querySelector('[data-tea-picker]');
    var hiddenInput = section.querySelector('[data-tea-variant-id]');
    var priceLabel = section.querySelector('[data-tea-price]');
    var sizeLabel = section.querySelector('[data-tea-size-label]');
    var ctaPrices = section.querySelectorAll('[data-tea-cta-price]');
    var stickyOption = section.querySelector('[data-tea-sticky-option]');
    var stockLabel = section.querySelector('[data-tea-stock-label]');
    var stockWrap = section.querySelector('.tea-panel__stock');
    var addButtons = section.querySelectorAll('[data-tea-add]');
    var addLabels = section.querySelectorAll('[data-tea-add-label]');
    var stickyCart = section.querySelector('[data-tea-sticky-cart]');
    var sellingPicker = section.querySelector('[data-tea-selling-plan-picker]');
    var sellingPlanInput = section.querySelector('[data-tea-selling-plan-input]');
    var sellingModeButtons = Array.prototype.slice.call(section.querySelectorAll('[data-tea-selling-mode]'));
    var sellingPlanButtons = Array.prototype.slice.call(section.querySelectorAll('[data-tea-selling-plan]'));
    var sellingPlansWrap = section.querySelector('[data-tea-selling-plans]');
    var oneTimeMeta = section.querySelector('[data-tea-onetime-meta]');
    var subscribeMeta = section.querySelector('[data-tea-subscribe-meta]');
    var sellingSave = section.querySelector('[data-tea-selling-save]');
    var sellingState = {
      mode: 'onetime',
      planId: sellingPlanButtons[0] ? Number(sellingPlanButtons[0].dataset.teaSellingPlan || 0) : null
    };

    function selectedOptions() {
      var state = {};
      if (!picker) return state;
      picker.querySelectorAll('[data-tea-option-index]:checked').forEach(function (input) {
        state['option' + input.dataset.teaOptionIndex] = input.value;
      });
      return state;
    }

    function findVariant(state) {
      return variants.find(function (variant) {
        return (!state.option1 || variant.option1 === state.option1)
          && (!state.option2 || variant.option2 === state.option2)
          && (!state.option3 || variant.option3 === state.option3);
      }) || variants[0];
    }

    function combinationAvailable(candidate) {
      return variants.some(function (variant) {
        return (!candidate.option1 || variant.option1 === candidate.option1)
          && (!candidate.option2 || variant.option2 === candidate.option2)
          && (!candidate.option3 || variant.option3 === candidate.option3)
          && variant.available;
      });
    }

    function getSellingPlan(variant, planId) {
      var plans = variant && Array.isArray(variant.sellingPlans) ? variant.sellingPlans : [];
      return plans.find(function (plan) {
        return Number(plan.id) === Number(planId);
      }) || plans[0] || null;
    }

    function savingsPercent(variant, plan) {
      if (!variant || !plan || !variant.price || plan.price >= variant.price) return 0;
      return Math.round(((variant.price - plan.price) / variant.price) * 100);
    }

    function syncPicker() {
      if (!picker) return;
      var state = selectedOptions();
      var activeVariant = findVariant(state);

      picker.querySelectorAll('label').forEach(function (label) {
        var input = label.querySelector('[data-tea-option-index]');
        if (!input) return;
        var candidate = Object.assign({}, state);
        candidate['option' + input.dataset.teaOptionIndex] = input.value;
        var available = combinationAvailable(candidate);
        label.classList.toggle('is-active', input.checked);
        label.classList.toggle('is-disabled', !available);
        input.disabled = !available && !input.checked;
      });

      if (!activeVariant) return;
      var displayPrice = money(activeVariant.price);
      var activePlan = getSellingPlan(activeVariant, sellingState.planId);
      var hasSellingPlans = Boolean(activePlan);
      if (!hasSellingPlans) sellingState.mode = 'onetime';
      if (sellingState.mode === 'subscribe' && activePlan) {
        sellingState.planId = Number(activePlan.id);
      }
      var activeSellingPlan = getSellingPlan(activeVariant, sellingState.planId);
      var selectedPrice = sellingState.mode === 'subscribe' && activeSellingPlan
        ? money(activeSellingPlan.price)
        : displayPrice;
      var displayOption = activeVariant.option1 || activeVariant.title;
      if (hiddenInput) hiddenInput.value = activeVariant.id;
      if (priceLabel) priceLabel.textContent = selectedPrice;
      ctaPrices.forEach(function (label) {
        label.textContent = selectedPrice;
      });
      if (sizeLabel) sizeLabel.textContent = displayOption;
      if (stickyOption) stickyOption.textContent = displayOption;
      if (stockLabel) stockLabel.textContent = activeVariant.available ? 'In stock' : 'Sold out';
      if (stockWrap) stockWrap.classList.toggle('tea-panel__stock--soldout', !activeVariant.available);
      addButtons.forEach(function (button) {
        button.disabled = !activeVariant.available;
      });
      addLabels.forEach(function (label) {
        label.textContent = activeVariant.available ? 'Add to cart' : 'Sold out';
      });

      if (sellingPicker) {
        sellingPicker.hidden = !hasSellingPlans;
      }

      if (sellingPlanInput) {
        var shouldSubmitPlan = sellingState.mode === 'subscribe' && activeSellingPlan;
        sellingPlanInput.disabled = !shouldSubmitPlan;
        sellingPlanInput.value = shouldSubmitPlan ? activeSellingPlan.id : '';
      }

      sellingModeButtons.forEach(function (button) {
        var mode = button.dataset.teaSellingMode || 'onetime';
        var active = mode === sellingState.mode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-checked', active ? 'true' : 'false');
        if (mode === 'subscribe') button.disabled = !hasSellingPlans;
      });

      if (sellingPlansWrap) {
        var showPlans = sellingState.mode === 'subscribe' && hasSellingPlans;
        sellingPlansWrap.classList.toggle('is-open', showPlans);
        sellingPlansWrap.setAttribute('aria-hidden', showPlans ? 'false' : 'true');
      }

      if (oneTimeMeta) oneTimeMeta.textContent = displayPrice + ' - ship once';
      if (subscribeMeta && activePlan) subscribeMeta.textContent = money(activePlan.price) + ' - recurring delivery';

      var percent = savingsPercent(activeVariant, activePlan);
      if (sellingSave) {
        sellingSave.hidden = percent <= 0;
        sellingSave.textContent = percent > 0 ? 'Save ' + percent + '%' : '';
      }

      sellingPlanButtons.forEach(function (button) {
        var planId = Number(button.dataset.teaSellingPlan || 0);
        var plan = getSellingPlan(activeVariant, planId);
        var active = activeSellingPlan && Number(activeSellingPlan.id) === planId;
        var price = button.querySelector('[data-tea-selling-plan-price]');
        button.disabled = !plan;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-checked', active ? 'true' : 'false');
        if (price) price.textContent = plan ? money(plan.price) : '';
      });
    }

    if (picker) {
      on(picker, 'change', syncPicker);
      on(picker, 'click', function (event) {
        if (event.target.closest('.is-disabled')) event.preventDefault();
      });
      syncPicker();
    }

    sellingModeButtons.forEach(function (button) {
      on(button, 'click', function () {
        if (button.disabled) return;
        sellingState.mode = button.dataset.teaSellingMode || 'onetime';
        syncPicker();
      });
    });

    sellingPlanButtons.forEach(function (button) {
      on(button, 'click', function () {
        if (button.disabled) return;
        sellingState.mode = 'subscribe';
        sellingState.planId = Number(button.dataset.teaSellingPlan || 0);
        syncPicker();
      });
    });

    var qty = section.querySelector('[data-tea-qty]');
    var dec = section.querySelector('[data-tea-qty-dec]');
    var inc = section.querySelector('[data-tea-qty-inc]');
    if (qty && dec && inc) {
      on(dec, 'click', function () {
        qty.value = Math.max(1, Number(qty.value || 1) - 1);
      });
      on(inc, 'click', function () {
        qty.value = Math.max(1, Number(qty.value || 1) + 1);
      });
    }

    if (stickyCart) {
      var showStickyCart = function () {
        var trigger = section.querySelector('.tea-cta') || picker || section;
        var rect = trigger.getBoundingClientRect();
        var shouldShow = window.scrollY > 120 && rect.bottom < 80;
        stickyCart.classList.toggle('is-visible', shouldShow);
      };

      showStickyCart();
      on(window, 'scroll', showStickyCart, { passive: true });
      on(window, 'resize', showStickyCart);
    }

    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-tea-slide]'));
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-tea-thumb]'));
    var current = 0;

    function showSlide(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === current);
        thumb.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb, index) {
      on(thumb, 'click', function () {
        showSlide(index);
      });
    });

    var prev = section.querySelector('[data-tea-prev]');
    var next = section.querySelector('[data-tea-next]');
    on(prev, 'click', function () { showSlide(current - 1); });
    on(next, 'click', function () { showSlide(current + 1); });
  });

  document.querySelectorAll('[data-tea-faq-section]').forEach(function (section) {
    if (section.dataset.teaFaqInitialized === 'true') return;
    section.dataset.teaFaqInitialized = 'true';

    section.addEventListener('toggle', function (event) {
      var item = event.target;
      if (!item.matches('details[open]')) return;
      section.querySelectorAll('details[open]').forEach(function (openItem) {
        if (openItem !== item) openItem.removeAttribute('open');
      });
    }, true);
  });
})();
